import FooterWrapper from 'components/FooterWrapper';
import GlobalActions from 'components/GlobalActions';
import NavigationWrapper from 'components/NavigationWrapper';
import { PropsWithChildren } from 'react';

type Props = {
  currentPage?: string;
  locationSlug?: string;
  wideFooter?: boolean;
};

export default function ApplicationLayout({ currentPage, children, locationSlug, wideFooter = false }: PropsWithChildren<Props>) {
  return (
    <>
      <GlobalActions />
      <div id="header">
        <NavigationWrapper currentPage={currentPage} locationSlug={locationSlug} />
      </div>
      {children}
      <FooterWrapper wideFooter={wideFooter} />
    </>
  );
}
